module.exports = __webpack_public_path__ + "img/logo-rossignol.216c5579.svg";